import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from '../../axios/axiosconf';
import Header from '../general/Header';
import Aside from '../general/Aside';
import Footer from '../general/Footer';

function RipsConvenios() {
    const [rips, setRips] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [filtroTipo, setFiltroTipo] = useState('');
    const [seleccionados, setSeleccionados] = useState([]);
    const [seleccionarTodos, setSeleccionarTodos] = useState(false);

    useEffect(() => {
        // Establecer fechas por defecto (mes actual)
        const hoy = new Date();
        const primerDia = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
        const ultimoDia = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0);
        
        setFechaInicio(primerDia.toISOString().split('T')[0]);
        setFechaFin(ultimoDia.toISOString().split('T')[0]);
    }, []);

    useEffect(() => {
        if (fechaInicio && fechaFin) {
            cargarRips();
        }
    }, [fechaInicio, fechaFin, filtroTipo]);

    const cargarRips = async () => {
        setLoading(true);
        setSeleccionados([]);
        setSeleccionarTodos(false);
        try {
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            const response = await axios.get('/rips', {
                params: {
                    uid: userdata.user_id,
                    fecha_inicio: fechaInicio,
                    fecha_fin: fechaFin,
                    tipo: filtroTipo,
                    estado: 2 // Solo RIPS por convenio (estado 2)
                }
            });
            setRips(response.data);
        } catch (error) {
            console.error('Error cargando RIPS:', error);
            alert('Error al cargar los registros RIPS');
        } finally {
            setLoading(false);
        }
    };

    const handleSeleccionarTodos = (e) => {
        const checked = e.target.checked;
        setSeleccionarTodos(checked);
        if (checked) {
            setSeleccionados(rips.map(item => item.id));
        } else {
            setSeleccionados([]);
        }
    };

    const handleSeleccionar = (ripsId) => {
        if (seleccionados.includes(ripsId)) {
            setSeleccionados(seleccionados.filter(id => id !== ripsId));
            setSeleccionarTodos(false);
        } else {
            const nuevosSeleccionados = [...seleccionados, ripsId];
            setSeleccionados(nuevosSeleccionados);
            if (nuevosSeleccionados.length === rips.length) {
                setSeleccionarTodos(true);
            }
        }
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        const date = new Date(fecha);
        return date.toLocaleDateString('es-CO');
    };

    const formatearValor = (valor) => {
        if (!valor || valor === 0) return '-';
        return '$' + Math.round(parseFloat(valor)).toLocaleString('es-CO');
    };

    const getTipoRegistro = (rips) => {
        const tipos = [];
        if (rips.consultas) tipos.push('Consulta');
        if (rips.procedimientos) tipos.push('Procedimiento');
        return tipos.join(' + ') || 'N/A';
    };

    const calcularTotalSeleccionados = () => {
        return rips
            .filter(item => seleccionados.includes(item.id))
            .reduce((total, item) => total + parseFloat(item.valor_rips || 0), 0);
    };

    const generarFactura = () => {
        if (seleccionados.length === 0) {
            alert('Debe seleccionar al menos un registro RIPS');
            return;
        }

        // Redirigir a CrearFacturaRips con los IDs seleccionados
        const ripsIdsParam = seleccionados.join(',');
        window.location.href = `/#/crear-factura-rips?rips_ids=${ripsIdsParam}`;
    };

    return (
        <div className="hold-transition">
            <Header />
            <Aside activelink="indicators" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0">RIPS por Convenios</h1>
                            </div>
                            <div className="col-sm-6">
                                <Link to="/indicadores" className="btn btn-secondary float-right">
                                    <i className="fas fa-arrow-left"></i> Volver
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title">Filtros de Búsqueda</h3>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Fecha Inicio</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fechaInicio}
                                                onChange={(e) => setFechaInicio(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Fecha Fin</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fechaFin}
                                                onChange={(e) => setFechaFin(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Tipo de Registro</label>
                                            <select
                                                className="form-control"
                                                value={filtroTipo}
                                                onChange={(e) => setFiltroTipo(e.target.value)}
                                            >
                                                <option value="">Todos</option>
                                                <option value="consulta">Solo Consultas</option>
                                                <option value="procedimiento">Solo Procedimientos</option>
                                                <option value="ambos">Consulta + Procedimiento</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>&nbsp;</label>
                                            <button
                                                className="btn btn-primary btn-block"
                                                onClick={cargarRips}
                                            >
                                                <i className="fas fa-search"></i> Buscar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {seleccionados.length > 0 && (
                            <div className="card bg-light">
                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <div className="col-md-6">
                                            <h5 className="mb-0">
                                                <i className="fas fa-check-circle text-success"></i> {seleccionados.length} registros seleccionados
                                            </h5>
                                            <p className="mb-0 text-muted">
                                                Total: <strong>{formatearValor(calcularTotalSeleccionados())}</strong>
                                            </p>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <button
                                                className="btn btn-success btn-lg"
                                                onClick={generarFactura}
                                            >
                                                <i className="fas fa-file-invoice-dollar"></i> Generar Factura
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title">RIPS Pendientes de Facturación</h3>
                                <div className="card-tools">
                                    <span
                                        className="badge"
                                        style={{
                                            background: 'rgba(255, 193, 7, 0.16)',
                                            color: '#8a6d1f',
                                            border: '1px solid rgba(255, 193, 7, 0.35)',
                                            borderRadius: '999px',
                                            fontWeight: 700,
                                            padding: '0.35rem 0.6rem'
                                        }}
                                    >
                                        {rips.length} registros
                                    </span>
                                </div>
                            </div>
                            <div className="card-body">
                                {loading ? (
                                    <div className="text-center">
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">Cargando...</span>
                                        </div>
                                        <p>Cargando registros...</p>
                                    </div>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th style={{width: '50px'}}>
                                                        <div className="custom-control custom-checkbox">
                                                            <input
                                                                type="checkbox"
                                                                className="custom-control-input"
                                                                id="selectAll"
                                                                checked={seleccionarTodos}
                                                                onChange={handleSeleccionarTodos}
                                                            />
                                                            <label className="custom-control-label" htmlFor="selectAll"></label>
                                                        </div>
                                                    </th>
                                                    <th>Fecha</th>
                                                    <th>Tipo</th>
                                                    <th>Paciente</th>
                                                    <th>Profesional</th>
                                                    <th>Valor</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {rips.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="6" className="text-center">
                                                            No se encontraron registros RIPS pendientes de facturación
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    rips.map((item) => (
                                                        <tr key={item.id} className={seleccionados.includes(item.id) ? 'table-active' : ''}>
                                                            <td>
                                                                <div className="custom-control custom-checkbox">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="custom-control-input"
                                                                        id={`check-${item.id}`}
                                                                        checked={seleccionados.includes(item.id)}
                                                                        onChange={() => handleSeleccionar(item.id)}
                                                                    />
                                                                    <label className="custom-control-label" htmlFor={`check-${item.id}`}></label>
                                                                </div>
                                                            </td>
                                                            <td>{formatearFecha(item.fecha)}</td>
                                                            <td>{getTipoRegistro(item)}</td>
                                                            <td>
                                                                <small>
                                                                    <strong>{item.paciente_nombre}</strong><br />
                                                                    {item.paciente_tipo_doc} {item.paciente_numero_doc}
                                                                </small>
                                                            </td>
                                                            <td>
                                                                <small>{item.profesional_nombre}</small>
                                                            </td>
                                                            <td className="text-right">
                                                                <strong>{formatearValor(item.valor_rips)}</strong>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default RipsConvenios;
